<template>
  <v-card tile>
    <v-card-title>Administratorji</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="users.data"
        :page.sync="users.current_page"
        :items-per-page="users.per_page"
        :server-items-length="users.total"
        :options.sync="tableOptions"
        :search="search"
        @update:options="loadUsers"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50],
        }"
        sort-by="id"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              @change="loadUsers"
              append-icon="mdi-magnify"
              label="Iskalnik"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Dodaj</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Uporabnik</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.name"
                          label="Ime"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.email"
                          label="Email"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.password"
                          label="Geslo"
                          type="password"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.password_confirmation"
                          label="Ponovite geslo"
                          type="password"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6" md="6">
                        <v-checkbox
                          v-model="editedItem.blocked"
                          label="Blokiran"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <TooltipIconButton
            tooltip="Uredi"
            icon="mdi-pencil"
            @click="editItem(item)"
          ></TooltipIconButton>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="loadUsers">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
  import TooltipIconButton from "../components/TooltipIconButton.vue";

  export default {
    data: () => ({
      dialog: false,
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        { text: "Ime", value: "name" },
        { text: "Email", value: "email" },
        { text: "", value: "actions", sortable: false },
      ],
      users: {
        data: [],
      },
      editedIndex: -1,
      editedItem: {},
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      search: "",
    }),
    methods: {
      loadUsers() {
        let orderBy = {};
        if (
          this.tableOptions.sortBy.length > 0 &&
          this.tableOptions.sortDesc.length > 0
        ) {
          orderBy[this.tableOptions.sortBy[0]] =
            this.tableOptions.sortDesc[0] === true ? "desc" : "asc";
        }
        let params = {
          page: this.tableOptions.page,
          perPage: this.tableOptions.itemsPerPage,
          orderBy,
        };

        if (this.search !== "") {
          params["filters"] = { name: encodeURI("%" + this.search + "%") };
        }

        this.$http.get("api/v1/users", { params }).then((response) => {
          this.users = response.data;
        });
      },
      editItem(item) {
        this.editedIndex = this.users.data.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {
        if (this.editedIndex !== -1) {
          this.$http
            .put(
              "api/v1/users/" + this.users.data[this.editedIndex].id,
              this.editedItem
            )
            .then((response) => {
              this.$set(this.users.data, this.editedIndex, response.data);
              this.close();
            });
          return;
        }

        this.$http.post("api/v1/users", this.editedItem).then(() => {
          this.loadUsers();
          this.close();
        });
      },
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
    components: { TooltipIconButton },
  };
</script>
<style></style>
